import { postEntity } from './postEntity';
import { Dispatchable, dispatchable } from 'module/Redux';
import { MelezeApi } from 'module/Service/MelezeApi';
import { PostKey } from './index';
import { LoggerUtils } from 'module/Common';

export namespace PostAction {
  export const fetchPost = (key: PostKey): Dispatchable => {
    try {
      const prefetched = MelezeApi.getPrefetchedPost(key);
      if (prefetched !== null) {
        return postEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.resolved(prefetched) }));
      }
    } catch (error) {
      LoggerUtils.logError(error);
      // return postEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.rejected(error) }));
    }
    return dispatchable([
      postEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.pending(null) })),
      MelezeApi.getPost(key)
        .then(post => postEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.resolved(post) })))
        .catch(e => {
          LoggerUtils.logError(e);
          return postEntity.actionCreators.byKeyAction(res => ({ key, resourceAction: res.rejected(e) }));
        }),
    ]);
  };
}



// WEBPACK FOOTER //
// ./src/module/Redux/Post/PostAction.ts